import { useAtomValue } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";

export function useDraftReturn(orderId: string) {
  return useAtomValue(draftReturnAtomFamily(orderId));
}
